var map = {
	"./": [
		"8hXn",
		0,
		1
	],
	"./changchengshuyuan": [
		"Cb50",
		2,
		0
	],
	"./changchengshuyuan.vue": [
		"Cb50",
		2,
		0
	],
	"./chuzhong": [
		"Nlu6",
		0,
		6
	],
	"./chuzhong.vue": [
		"Nlu6",
		0,
		6
	],
	"./guojigaozhong": [
		"ERee",
		0,
		4
	],
	"./guojigaozhong.vue": [
		"ERee",
		0,
		4
	],
	"./index": [
		"8hXn",
		0,
		1
	],
	"./index.vue": [
		"8hXn",
		0,
		1
	],
	"./laihua": [
		"jsz1",
		8
	],
	"./laihua.vue": [
		"jsz1",
		8
	],
	"./news_info": [
		"TVAq",
		0,
		12
	],
	"./news_info.vue": [
		"TVAq",
		0,
		12
	],
	"./tansuo": [
		"rmRv",
		0,
		5
	],
	"./tansuo.vue": [
		"rmRv",
		0,
		5
	],
	"./tongzhouhuaren": [
		"lKxa",
		0,
		9
	],
	"./tongzhouhuaren.vue": [
		"lKxa",
		0,
		9
	],
	"./tuifeizhengce": [
		"zP2R",
		0,
		13
	],
	"./tuifeizhengce.vue": [
		"zP2R",
		0,
		13
	],
	"./xiaoxue": [
		"278J",
		3
	],
	"./xiaoxue.vue": [
		"278J",
		3
	],
	"./yinsizhengce": [
		"G8lp",
		0,
		11
	],
	"./yinsizhengce.vue": [
		"G8lp",
		0,
		11
	],
	"./zhaosheng": [
		"ILuw",
		0,
		10
	],
	"./zhaosheng.vue": [
		"ILuw",
		0,
		10
	],
	"./zhongjiaxuexiao": [
		"h6Ji",
		0,
		7
	],
	"./zhongjiaxuexiao.vue": [
		"h6Ji",
		0,
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "MWF8";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*$
// module id = MWF8
// module chunks = 16